<template>
  <div class="jin-product">
    <div class="jin-product-title">
      <img src="~@/assets/mobile/product/英文装饰@2x.png" alt="">
      <div class="jin-product-title-zh">金十数据主打产品</div>
      <div class="jin-product-title-en">Jin10 Main Products</div>
    </div>
    <div class="jin-product-content">
      <div class="jin-product-content-wrap mb-20">
        <div class="jin-product-content-item mr-42">
          <img v-lazy="require('@/assets/mobile/product/金十数据@2x.png')" alt="">
          <div class="jin-product-content-item-title">金十数据</div>
        </div>
        <div class="jin-product-content-item">
          <img v-lazy="require('@/assets/mobile/product/交易侠@2x.png')" alt="">
          <div class="jin-product-content-item-title">交易侠</div>
        </div>
      </div>
      <div class="jin-product-content-wrap">
        <div class="jin-product-content-item mr-42">
          <img v-lazy="require('@/assets/mobile/product/美港电讯@2x.png')" alt="">
          <div class="jin-product-content-item-title">美港电讯</div>
        </div>
        <div class="jin-product-content-item mr-42">
          <img v-lazy="require('@/assets/mobile/product/金十期货@2x.png')" alt="">
          <div class="jin-product-content-item-title">金十期货</div>
        </div>
        <div class="jin-product-content-item">
          <img v-lazy="require('@/assets/mobile/product/数鸽@2x.png')" alt="">
          <div class="jin-product-content-item-title">数鸽</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.jin-product {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    // padding-bottom:51px;
    background: #FFF;
    .jin-product-title {
      position: relative;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3D4351;
      line-height: 27px;
      text-align: center;
      img {
        width: 100%;
        height: 21px;
      }
      .jin-product-title-zh {
        margin-top: -5px;
      }
      .jin-product-title-en {
        margin-top: 2px;
        height: 16px;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #787B8A;
        line-height: 16px;
      }
    }
    .jin-product-content {
      width: 100%;
      height: 200px;
      margin-top: -16px;
      padding-top: 52px;
      background: url("~@/assets/index/product/背景素材@2x.png") no-repeat;
      background-size: 100% 100%;
      .jin-product-content-wrap {
        display: flex;
        justify-content: center;
        width: 100%;
        // height:87px;
        // margin: 0 auto;
        .jin-product-content-item {
          width: 53px;
          img {
            width: 100%;
          }
          .jin-product-content-item-title {
            margin-top: 5px;
            height: 16px;
            font-size: 11px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #3D4351;
            line-height: 16px;
            text-align: center;
          }
        }
        .mr-42 {
          margin-right: 42px;
        }
      }
      .mb-20 {
        margin-bottom: 20px;
      }
      .jin-product-content-item1 {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin: 12px auto;
        img {
          width: 163px;
          height: 87px;
        }
      }
      .jin-product-content-item2 {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin: 0 auto;
        img {
          width: 163px;
          height: 87px;
        }
      }
    }
}
</style>
